<template>
	<article class="prod-box" v-click-outside="pauseVideo">
		<figure v-if="!product.video" class="prod-box__figure">
			<a
				class="prod-box__zoom"
				:href="product.imgFull"
				data-lightbox="product-lightbox"
				:data-title="`${product.name} ${product.sku ? `(${product.sku})` : ''}`"
				rel="product_images"
			>
				<svg data-v-54a3f4=""><use xlink:href="#search-light"></use></svg>
			</a>
			<img class="prod-box__img" :src="product.img" :alt="product.name" />
			<div v-if="product.premium === 'y'" class="premium-icon">
				<svg class="premium-icon__icon">
					<use xlink:href="#gem-solid"></use>
				</svg>
				<p class="premium-icon__text">Premium</p>
			</div>
		</figure>
		<a v-if="!product.video" :href="product.href">
			<div class="prod-box__overlay">
				<div class="prod-box__text-wrap">
					<h2 class="prod-box__title">
						{{ product.name }}
					</h2>
					<p class="prod-box__subtitle">{{ product.sku ? product.sku : "" }}</p>
				</div>
			</div>
		</a>
		<figure v-else class="prod-box__figure">
			<a :href="product.href">
				<video
					ref="video"
					muted
					preload="none"
					playsinline="none"
					controls="none"
					:poster="product.img"
				>
					<source :src="product.video" type="video/mp4" />
				</video>
			</a>

			<div v-if="product.premium  === 'y'" class="premium-icon">
				<svg class="premium-icon__icon">
					<use xlink:href="#gem-solid"></use>
				</svg>
				<p class="premium-icon__text">Premium</p>
			</div>
		</figure>
		<div
			v-if="product.video"
			class="prod-box__overlay prod-box__overlay--video"
		>
			<div class="prod-box__text-wrap">
				<a :href="product.href">
					<h2 class="prod-box__title">{{ product.name }}</h2>
				</a>
				<p class="prod-box__subtitle">{{ product.sku ? product.sku : "" }}</p>
			</div>
		</div>
	</article>
</template>

<script>
	import Plyr from "plyr";
	export default {
		name: "Product",
		props: ["product"],
		data() {
			return {
				player: false,
			};
		},

		methods: {
			initVideo() {
				this.player = new Plyr(this.$refs["video"]);
				const button = this.player.elements.buttons.play[0];
				button.addEventListener("click", (e) => {
					e.preventDefault();
					this.player.play();
				});
			
			},
			pauseVideo() {
				if (this.player) {
					this.player.pause();
				}
			},
		},

		mounted() {
			if (this.product.video) {
				this.initVideo();
			}
		},
	};
</script>
